import { render, staticRenderFns } from "./BcSheet.vue?vue&type=template&id=2cc7c578&scoped=true"
import script from "./BcSheet.vue?vue&type=script&lang=js"
export * from "./BcSheet.vue?vue&type=script&lang=js"
import style0 from "./BcSheet.vue?vue&type=style&index=0&id=2cc7c578&prod&lang=scss&scoped=true"
import style1 from "./BcSheet.vue?vue&type=style&index=1&id=2cc7c578&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc7c578",
  null
  
)

export default component.exports